// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#acContainer.mobile {
  height: 100vh;
  width: 100vw;
  background-color: white;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1991 !important;
}

.acInput {
  width: 100% !important;
}

.acInput-mobile-container {
  position: fixed !important;
  top: 0;
  z-index: 1992 !important;
  width: calc(100vw - 24px);
  border: 1px #c8c8c8 solid;
  border-radius: 5px;
  margin: 8px 12px;
}
.acInput-mobile-container .acInput-mobile {
  width: calc(100vw - 40px);
  border: 0;
  padding: 8px 10px 0px 10px;
  margin: 0 0 6px 6px;
  font-size: 20px;
  background-color: white;
}
.acInput-mobile-container .acInput-mobile:focus {
  outline: 0 !important;
}
.acInput-mobile-container button {
  margin-top: 2px;
  padding: 0 !important;
  height: 40px;
  font-size: 1.5rem;
  color: #6e6e6e;
  width: 40px !important;
  min-width: 40px !important;
}
.acInput-mobile-container button i {
  color: #6e6e6e;
  top: 6px;
}

.acOptions {
  margin-top: 60px;
  margin-bottom: 60px;
  height: calc(100vh - 120px);
  overflow-y: auto;
}
.acOptions .acOption {
  color: #424242;
  border-bottom: 1px #e8e8e8 solid;
  padding: 14px;
}
.acOptions .acOption:hover {
  background-color: rgb(241, 241, 241);
}

.mobile-buttons {
  background-color: #023b48 !important;
  color: white !important;
  position: fixed;
  height: 50px;
  bottom: 0px;
  font-size: 14px;
  left: 0px;
  width: 100%;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
  box-shadow: 0px -1px 4px 0px rgb(120, 120, 120);
  z-index: 1993 !important;
}
.mobile-buttons button {
  display: inline-block;
  margin-top: 4px;
  vertical-align: middle;
}

.matForm {
  width: 100%;
}

.matFormMobile {
  width: 100%;
}
.matFormMobile input {
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/directivas/components/ax-autocomplete/ax-autocomplete.component.scss","webpack://./src/assets/css/colores.scss"],"names":[],"mappings":"AAGE;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,wBAAA;AAFJ;;AAMA;EACE,sBAAA;AAHF;;AAcA;EACE,0BAAA;EACA,MAAA;EACA,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAXF;AAYE;EACE,yBAAA;EACA,SAAA;EACA,0BAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;AAVJ;AAWI;EACE,qBAAA;AATN;AAYE;EACE,eAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,cC5BO;ED6BP,sBAAA;EACA,0BAAA;AAVJ;AAWI;EACE,cChCK;EDiCL,QAAA;AATN;;AAcA;EACE,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;AAXF;AAYE;EACE,cC1Cc;ED2Cd,gCAAA;EACA,aAAA;AAVJ;AAWI;EACE,oCAAA;AATN;;AAcA;EACE,oCAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EAGA,+CAAA;EACA,wBAAA;AAXF;AAYE;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;AAVJ;;AAcA;EACE,WAAA;AAXF;;AAaA;EACE,WAAA;AAVF;AAWE;EACE,eAAA;AATJ","sourcesContent":["@import \"../../../../assets/css/colores.scss\";\r\n\r\n#acContainer {\r\n  &.mobile {\r\n    height: 100vh;\r\n    width: 100vw;\r\n    background-color: white;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 1991 !important;\r\n  }\r\n}\r\n\r\n.acInput{\r\n  width: 100% !important;\r\n}\r\n// mat-form-field {\r\n//   .mat-form-field-infix{\r\n//     padding: .5em 0 .5em 0 !important;\r\n//   }\r\n// }\r\n// .mat-form-field-appearance-outline .mat-form-field-infix{\r\n//\r\n// }\r\n\r\n.acInput-mobile-container {\r\n  position: fixed !important;\r\n  top: 0;\r\n  z-index: 1992 !important;\r\n  width: calc(100vw - 24px);\r\n  border: 1px #c8c8c8 solid;\r\n  border-radius: 5px;\r\n  margin: 8px 12px;\r\n  .acInput-mobile {\r\n    width: calc(100vw - 40px);\r\n    border: 0;\r\n    padding: 8px 10px 0px 10px;\r\n    margin: 0 0 6px 6px;\r\n    font-size: 20px;\r\n    background-color: white;\r\n    &:focus {\r\n      outline: 0 !important;\r\n    }\r\n  }\r\n  button {\r\n    margin-top: 2px;\r\n    padding: 0 !important;\r\n    height: 40px;\r\n    font-size: 1.5rem;\r\n    color: $oa-gris;\r\n    width: 40px !important;\r\n    min-width: 40px !important;\r\n    i {\r\n      color: $oa-gris;\r\n      top: 6px;\r\n    }\r\n  }\r\n}\r\n\r\n.acOptions {\r\n  margin-top: 60px;\r\n  margin-bottom: 60px;\r\n  height: calc(100vh - 120px);\r\n  overflow-y: auto;\r\n  .acOption {\r\n    color: $oa-gris-oscuro;\r\n    border-bottom: 1px #e8e8e8 solid;\r\n    padding: 14px;\r\n    &:hover {\r\n      background-color: rgb(241, 241, 241);\r\n    }\r\n  }\r\n}\r\n\r\n.mobile-buttons {\r\n  background-color: $oa-background !important;\r\n  color: white !important;\r\n  position: fixed;\r\n  height: 50px;\r\n  bottom: 0px;\r\n  font-size: 14px;\r\n  left: 0px;\r\n  width: 100%;\r\n  text-align: center;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  -webkit-box-shadow: 0px -1px 4px 0px rgba(120, 120, 120, 1);\r\n  -moz-box-shadow: 0px -1px 4px 0px rgba(120, 120, 120, 1);\r\n  box-shadow: 0px -1px 4px 0px rgba(120, 120, 120, 1);\r\n  z-index: 1993 !important;\r\n  button {\r\n    display: inline-block;\r\n    margin-top: 4px;\r\n    vertical-align: middle;\r\n  }\r\n}\r\n\r\n.matForm{\r\n  width:100%\r\n}\r\n.matFormMobile{\r\n  width:100%;\r\n  input {\r\n    font-size: 20px;\r\n  }\r\n}\r\n","\r\n$oa-principal : #d20a31;\r\n$oa-principal2 : #6d0015;\r\n$oa-principal3 : #f06f88;\r\n\r\n$oa-secundario : #0a738c;\r\n$oa-secundario2 : #023b48;\r\n$oa-secundario3 : #539cad;\r\n\r\n$oa-accent : #46c309;\r\n$oa-accent2 : #216500;\r\n$oa-accent3 : #90e268;\r\n\r\n$oa-accent-secundario : #E1750B;\r\n$oa-accent-secundario2 : #753A00;\r\n$oa-accent-secundario3 : #FFBA76;\r\n\r\n$oa-background : #023b48;\r\n\r\n$oa-blanco-bg : white;\r\n$oa-blanco : white;\r\n\r\n$oa-gris : #6e6e6e;\r\n$oa-gris-claro : #a3a3a3;\r\n$oa-gris-oscuro : #424242;\r\n\r\n$oa-color-link: #3e92ff;\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
